module.exports = __webpack_public_path__ + "img/linux.bc3a6d23.png";